/**
 * Desabilita logs verbosos de debug no console
 * Mantém apenas console.error e console.warn para diagnóstico
 */

const ENABLE_DEBUG_LOGS = false; // Mude para true para ver todos os logs

if (!ENABLE_DEBUG_LOGS) {
  // Salva as funções originais
  const originalLog = console.log;
  const originalInfo = console.info;

  // Sobrescreve para não fazer nada
  console.log = () => {};
  console.info = () => {};

  // Mantém error e warn funcionando normalmente
  // console.error e console.warn continuam ativos

  // Para desenvolvedores: use console.error() para logs importantes que precisam aparecer sempre
}

export {};
